import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getComission = async (dataOrigen, refrescar, api, token, body, config) => {

  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.commission_data.length <= 0 || data.date_from !== config.startDate || data.date_to !== config.endDate) {
    const response = await axios(configws)
    data = {  commission_data: base64ToString(response) }
  }

  const comissionStatus = {
      0: { tooltip: 'Cobro Ingresado' }, 
      1: { tooltip: 'Hoja de S.P. Ingresada' }, 
      2: { tooltip: 'Cobro Anulado' },
      3: { tooltip: 'Revisado' },
      4: { tooltip: 'Unificado' },
      5: { tooltip: 'Facturada' }
  }

  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1, status = null, sort, sortColumn } = config

  /* eslint-enable */
  const dataAsc = data.commission_data.sort((a, b) => {

    if (a[sortColumn] !== undefined && b[sortColumn] !== undefined) {
      if (typeof a[sortColumn] === 'number' && typeof b[sortColumn] === 'number' && sortColumn === 'comision_status') {
        return a[sortColumn] - b[sortColumn]
      } else {

        if (sortColumn === 'comision_status') {
          const aSort = comissionStatus[a[sortColumn]].tooltip
          const bSort = comissionStatus[b[sortColumn]].tooltip
          return aSort.toString().localeCompare(bSort.toString())
        } else {
          return a[sortColumn].toString().localeCompare(b[sortColumn].toString())
        }
      }
    } else {
      const splitColumn = sortColumn.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      
      if (typeof columnA === 'number' && typeof columnB === 'number') {
        return columnA - columnB
      } else {
        return columnA.toString().localeCompare(columnB.toString())
      }
    }
  })

  const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

  const queryLowered = q.toLowerCase()
  const filteredData = dataToFilter.filter(comision_data => {

      return (
        (
          String(comision_data.comision_id).toLowerCase().includes(queryLowered) ||
          comision_data.date.toLowerCase().includes(queryLowered) ||
          String(comision_data.id_closure).toLowerCase().includes(queryLowered) ||
          comision_data.user_closure.toLowerCase().includes(queryLowered) ||
          comision_data.amount.toLowerCase().includes(queryLowered) ||
          comision_data.exchange_rate.toLowerCase().includes(queryLowered) ||
          comision_data.payment_method.toLowerCase().includes(queryLowered) ||
          (comision_data.bank && comision_data.bank.toLowerCase().includes(queryLowered)) ||
          (comision_data.invoice_or_receipt && comision_data.invoice_or_receipt.toLowerCase().includes(queryLowered)) ||
          (comision_data.user_decline && comision_data.user_decline.toLowerCase().includes(queryLowered)) ||
          comision_data.currency.toLowerCase().includes(queryLowered)           
        ) 
        && 
        comision_data.comision_status === (status.length > 0 ? Number(status) : comision_data.comision_status)
      )
  })

  return [
    200,
    {
      allData: data.commission_data,
      total: filteredData.length,
      commission_data: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page)
    }
  ]  
}

// ------------------------------------------------
// GET: Return closure List for Comission
// ------------------------------------------------
let dataComission = JSON.parse(localStorage.getItem("dataComission")) || { commission_data: [], date_from: '', date_to: '', cluster: -1, country: -1, office: -1, user: -1}

mock.onGet('/apps/comission/list').reply(async config => {

  const user = getUserData()
  
  let cluster_id = ''
  let office_id  = ''
  let country_id = ''
  let user_id    = ''

  if (config.manager) {
    if (config.cluster_id !== -1 && config.cluster_id !== '') {
      cluster_id = config.cluster_id
    }

    if (config.country_id !== -1 && config.country_id !== '') {
      country_id = config.country_id
    }

    if (config.office_id !== -1 && config.office_id !== '') {
      office_id = config.office_id
    }
      
    if (config.user_id !== -1 && config.user_id !== '') {
      user_id  = config.user_id
    }
  } else {
    cluster_id = user.usercoc.cluster
    office_id  = user.usercoc.office_id
    country_id = user.usercoc.country
    
    if (user.usercoc.role === 2) {
      user_id  = user.usercoc.user_id
    } else {
      user_id  = ""
    }
  }
  
  if (config.report) {
    if (config.user_id !== '') {
      user_id = config.user_id
    }
  }
  
  const body = {
    internal_closure_id : "",
    cluster             : cluster_id,
    country             : country_id,
    office              : office_id,
    user                : user_id,
    date_from           : config.startDate,
    date_to             : config.endDate,
    usercoc             : user.usercoc.user_id
  }

  if (localStorage.getItem("resetComision")) {
    if (localStorage.getItem("resetComision") === "true") {
      config.reset = true
    }

    localStorage.removeItem("resetComision")
  }

  const now = new Date()
  const diffInMinutes = (now - dataComission.last) / (1000 * 60)

  if (diffInMinutes >= 5) {
    config.reset = true
  }

  if (config.reset) {
    dataComission = { commission_data: [], date_from: '', date_to: '', cluster: -1, country: -1, office: -1, user: -1 }
  }

  const result = await getComission(dataComission, 1, GetApiCOC('getlistCommissiondata'), user.token, body, config)

  dataComission = { commission_data: result[1].allData, date_from: config.startDate, date_to: config.endDate, cluster: cluster_id, country: country_id, office: office_id, user: user_id }

  localStorage.setItem("dataComission", JSON.stringify(dataComission))

  return result
})
